import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectGroup,
  SelectItem,
} from "src/components/input/Select";
import { StateList } from "src/utils/states";

interface SelectStateProps {
  value: string;
  onValueChange: (value: string) => void;
}

export const SelectState = ({ value, onValueChange }: SelectStateProps) => {
  const states = StateList.map((state) => state.state);
  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger>
        <SelectValue placeholder="State" />
      </SelectTrigger>
      <SelectContent className="bg-white">
        <SelectGroup>
          <SelectItem value="all">All posts</SelectItem>
          {states.map((post) => (
            <SelectItem key={post} value={post}>
              {post}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
};
